import { useEffect, useState } from "react";
import { usePlan } from "../_providers/PlanProvider";
import { useModal } from "../_providers/ModalProvider";
import TransactionController from "../controllers/TransactionController";
import { useAuth } from "../_providers/AuthProvider";
import { Timestamp } from "firebase/firestore";

export const NewTransactionModal = (props: {category: string, type: "income" | "expense", onCreate: () => void}) => {
    const [desc, setDesc] = useState<string>("");
    const [amount, setAmount] = useState<number>(0);
    const [date, setDate] = useState<Date>(new Date());
    const [user, setUser] = useState<string>();
    const [error, setError] = useState<string | null>(null);
    const [recurrance, setRecurrance] = useState<{
        type: "days" | "weeks" | "months" | "years";
        value: number;
        end_date: Timestamp | null;
    } | null>(null);

    const {closeModal} = useModal();
    const {selectedPlan} = usePlan();

    const createHandler = () => {
        if(!selectedPlan) {
            setError("No plan selected");
            return;
        }
        if(desc.length < 3) {
            setError("Description is to short")
            return;
        }
        if(isNaN(amount) || amount === 0) {
            setError("Amount needs to be set to an amount > 0");
            return;
        }
        if(!user) {
            setError("User needs to be selected");
            return;
        }
        TransactionController.createTransaction(desc, props.category, props.type, selectedPlan.uid, amount, date, user, recurrance).then(() => {
            closeModal();
            props.onCreate();
        }
        ).catch((error) => {
            setError(error);
        }); 
    }

    const auth = useAuth();

    useEffect(() => {
        if(!auth.user) return;
        setUser(auth.user.uid);
    }, [auth.user]);

    return (
        <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
            <input
                type="text"
                placeholder="Description"
                value={desc}
                onChange={(e) => setDesc(e.target.value)}
            />
            <input
                type="number"
                placeholder="Amount"
                value={amount}
                onChange={(e) => setAmount(parseFloat(e.target.value))}
            />
            <input
                type="date"
                placeholder="Date"
                value={date.toISOString().split("T")[0]}
                onChange={(e) => setDate(new Date(e.target.value))}
            />
            <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                <label className="checkbox">
                    Make recurring
                    <input
                        type="checkbox"
                        onChange={(e) => {
                            if(e.target.checked) {
                                setRecurrance({
                                    type: "days",
                                    value: 1,
                                    end_date: null
                                });
                            } else {
                                setRecurrance(null);
                            }
                        }
                    }/>
                    <span className="checkmark"></span>
                </label>
                {recurrance && (
                    <div style={{ display: "flex", flexDirection: "column", gap: "10px", marginLeft: 10, paddingLeft: 10, borderLeft: "1px solid var(--border-color)" }}>
                        <select value={recurrance.type} onChange={(e) => setRecurrance({...recurrance, type: e.target.value as "days" | "weeks" | "months" | "years"})}>;
                            <option value="days">Days</option>
                            <option value="weeks">Weeks</option>
                            <option value="months">Months</option>
                            <option value="years">Years</option>
                        </select>
                        <input
                            type="number"
                            placeholder="Recurrence Value"
                            value={recurrance.value}
                            onChange={(e) => setRecurrance({...recurrance, value: parseInt(e.target.value)})}
                        />
                        <label className="checkbox">
                        Has end date
                        <input type="checkbox" onChange={(e) => {
                            if(e.target.checked) {
                                setRecurrance({...recurrance, end_date: Timestamp.fromDate(new Date())});
                            } else {
                                setRecurrance({...recurrance, end_date: null});
                            }
                        }}/>
                        <span className="checkmark"></span>
                        </label>
                        {recurrance.end_date && (
                            <>
                                <input
                                    type="date"
                                    placeholder="End Date"
                                    value={recurrance.end_date.toDate().toISOString().split("T")[0]}
                                    onChange={(e) => setRecurrance({...recurrance, end_date: Timestamp.fromDate(new Date(e.target.value))})}
                                />
                            </>
                        )}
                    </div>
                )}
            </div>
            <div className="select-wrapper">
                <select onChange={(e) => setUser(e.target.value)} value={user}>
                    {selectedPlan && selectedPlan.users.map((user) => (
                        <option key={user.uid} value={user.uid}>
                            {user.displayName}
                        </option>
                    ))}
                </select>
            </div>
            {error && <p style={{color: "red"}}>{error}</p>}
            <button className="btn" onClick={createHandler}><p>Create Transaction</p> <i className="fa-solid fa-plus" /></button>
        </div>
    )
}